import Footer from "../../FrontPage/components/Footer/Footer";
import Header from "../../FrontPage/components/Header/Header";
import LoginForm from "../component/login/login";
const NewLogin = () => {
  return (
    <div>
      <Header />
      <LoginForm />
      <Footer />
    </div>
  );
};

export default NewLogin;
